import { RTL_LANGUAGES } from "./constants"

export const getDirectionFromLanguage = (language) => {
  if (!language) return "ltr"
  const langCode = language.toLowerCase().split("-")[0]
  return RTL_LANGUAGES.includes(langCode) ? "rtl" : "ltr"
}

export const isRTLLanguage = (language) => {
  return getDirectionFromLanguage(language) === "rtl"
}
